import advisors from './advisors';
import ceos from './ceos';
import companies from './companies';
import guests from './guests';
import groups from './groups';
import events from './events';
import hosts from './hosts';
import trainings from './trainings';

export default {
  namespaced: true,
  modules: {
    advisors,
    ceos,
    companies,
    guests,
    groups,
    events,
    hosts,
    trainings,
  },
};
